import type { Id } from "@repo/db"
import { createFileRoute, useRouteContext } from "@tanstack/react-router"

import { VehicleDetailView } from "@/components/inventory/vehicle-detail-view"

export const Route = createFileRoute("/$dealership/inventory/$vehicleId")({
  staticData: {
    breadcrumb: "Vehicle",
  },
  component: VehicleDetailRoute,
})

function VehicleDetailRoute() {
  const context = useRouteContext({ from: "/$dealership" })
  const { vehicleId } = Route.useParams()

  if (!context.dealership) {
    return null
  }

  return <VehicleDetailView vehicleId={vehicleId as Id<"vehicles">} stores={context.stores} />
}
